import './src/styles/global.css';

console.log('do we get here')